const fetchSupplierByTargetId = (suppliers, targetId) => {
  return suppliers && suppliers.find(supplier => supplier.targets.find(target => target.id === targetId))
}

export { fetchSupplierByTargetId }
